'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';

export function Header() {
  const pathname = usePathname();
  const isHomePage = pathname === '/';
  
  const logoColorClass = isHomePage 
    ? 'text-primary' 
    : 'text-white';

  return (
    <header className="border-b bg-background/80 backdrop-blur-sm sticky top-0 z-50">
      <div className="container mx-auto flex h-16 items-center justify-between px-4">
        <Link 
          href="/" 
          className={`font-black text-2xl tracking-tight transition-transform hover:scale-105 ${logoColorClass}`}
        >
          Talksie
        </Link>
      </div>
    </header>
  );
}
